import { ga } from '../../../engine/ga-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { clickEater } from '../../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessAiRando } from '../ai/chessAiRando-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessGameRules } from '../chessGameRules-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { EChessHostCommand } from '../messages/chessMessageHostCommand'
import { chessMessageHostCommand } from '../messages/chessMessageHostCommand-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiGraphicsUtils } from './chessUiGraphicsUtils-sidecar'
import type { IChessUiGSelector } from './chessUiGSelectors'
import { chessUiGSelectors } from './chessUiGSelectors-sidecar'
import { chessUiSetupAI } from './chessUiSetupAI-sidecar'

interface IChessUiSetupGameRules extends IChessUiCanvas {
  selectorGameSpeed: IChessUiGSelector | null
}
let _obj: IChessUiSetupGameRules | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    createButtons()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 600
  let th = 700

  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiMessage)
  canvas.autoOffset = false

  let obj: IChessUiSetupGameRules =
    chessUiCanvas.assign<IChessUiSetupGameRules>(canvas, {
      selectorGameSpeed: null,
    })

  return obj
}

const createButtons = () => {
  let obj = get()
  obj.buttons = [
    chessUiGButtons.create('Cancel', 50, 50, () => {
      ga.action('click', 'game-rules-cancel')
      chessAiRando.killAll()
      setOpen(false)
    }),
    chessUiGButtons.create('Ok', 250, 50, () => {
      ga.action('click', 'game-rules-ok')
      setOpen(false)

      assert.notNil(obj.selectorGameSpeed)
      let gameSpeed = parseFloat(obj.selectorGameSpeed.value)
      chessMessageHostCommand.sendMessageAndImmediatelyExecute({
        command: EChessHostCommand.MoveTime,
        moveTime: gameSpeed,
      })
    }),

    chessUiGButtons.create('Reset', 250, 50, () => {
      ga.action('click', 'game-rules-reset')
      chessMessageHostCommand.sendMessageAndImmediatelyExecute({
        command: EChessHostCommand.Handicap,
        handicap: 0,
      })
      chessMessageHostCommand.sendMessageAndImmediatelyExecute({
        command: EChessHostCommand.Reset,
      })
    }),
  ]

  let sw = 520
  let lw = 250

  obj.selectors = [
    (obj.selectorGameSpeed = chessUiGSelectors.create(
      'Movement Delay',
      chessUiSetupAI.moveTimes,
      100,
      100,
      sw,
      lw,
    )),
  ]
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(chessFonts.get().f, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 0.4)
    obj.texts.push(_text)
    return _text
  }

  g.clear()

  let gb = chessCamera.getGameBounds()

  g.fillStyle(0x222222, 0.67)
  g.fillRect(0, 0, gb.width, gb.height)

  let w = obj.targetWidth
  let h = obj.targetHeight

  let x = (gb.width - w) / 2
  let y = (gb.height - h) / 2

  chessUiGraphicsUtils.bevelPanel(g, x, y, w, h)

  let title = addText('Game Rules', x + 6, y)
  stevieTexts2.setScale(title, 0.6)

  x += 10
  y += 40
  obj.selectors[0].x = x
  obj.selectors[0].y = y

  x = (gb.width - w) / 2
  y = (gb.height - h) / 2
  x += 20
  y += h - 60
  obj.buttons[0].x = x
  obj.buttons[0].y = y
  obj.buttons[1].x = x + 200
  obj.buttons[1].y = y
  obj.buttons[2].x = x + 400
  obj.buttons[2].y = y

  assert.notNil(obj.selectorGameSpeed)
  chessUiGSelectors.setEnabled(obj.selectorGameSpeed, websockets.getIsHost())

  chessUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean, onOk = () => {}) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
  if (isOpen) {
    assert.notNil(obj.selectorGameSpeed)
    chessUiGSelectors.setValue(
      obj.selectorGameSpeed,
      '' + chessGameRules.get().moveTime,
    )
    update()
  }
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    chessUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    chessUiCanvas.clear(obj)
  }
}
